import { Injectable, Type } from "@angular/core";
import { NatCatalogRepository } from "@natiwi/core/network/repositories/catalog.repository";
import { NatRestAdapter } from "@natiwi/core/network/adapters/rest.adapter";
import { OrmOrganizationBankAccount } from "@natiwi/shared/models/organization-bank-account.model";

export class NatOrganizationBankAccountRepository extends NatCatalogRepository<OrmOrganizationBankAccount> {

    constructor(adapter?: NatRestAdapter) {
        super(adapter);
        let repoUrl: string = '/organizationBankAccounts';
        let repoModel: Type<OrmOrganizationBankAccount> = OrmOrganizationBankAccount;
        this.init(repoUrl, repoModel);
    }
}